/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
`
export default class MessageIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" css={Color}>
        <g id="그룹_5476" data-name="그룹 5476" transform="translate(-1092.664 -1397.806)">
          <rect id="사각형_5472" data-name="사각형 5472" width="16" height="16" transform="translate(1092.664 1397.806)" fill="#fff" opacity="0"/>
          <path id="패스_5236" data-name="패스 5236" d="M1106.355,1399.543h-11.383a2.314,2.314,0,0,0-2.308,2.309v7.894a2.313,2.313,0,0,0,2.308,2.309h.085a.218.218,0,0,1,.025,0,.25.25,0,0,0,.04,0h11.014l0,.007h.031a.444.444,0,0,0,.064-.006l.044-.006h.076a2.315,2.315,0,0,0,2.309-2.309v-7.894A2.316,2.316,0,0,0,1106.355,1399.543Zm-5.3,6.2a.647.647,0,0,1-.778,0l-6.064-4.733a1.222,1.222,0,0,1,.813-.367h11.17a1.228,1.228,0,0,1,.833.384Zm-1.6.735.158.123a.429.429,0,0,0,.086.047.466.466,0,0,1,.055.028,1.628,1.628,0,0,0,.875.274h.043a.35.35,0,0,0,.06-.009.231.231,0,0,1,.046-.009,1.692,1.692,0,0,0,.533-.121,1.791,1.791,0,0,0,.413-.221l.3-.238,4.73,4.47a1.234,1.234,0,0,1-.558.15H1095.1a1.324,1.324,0,0,1-.324-.046Zm3.392-.776,4.726-3.733v7.775a1.064,1.064,0,0,1-.054.31Zm-4.2.146-4.768,4.436a1.141,1.141,0,0,1-.146-.54v-7.737Z" fill="#1c202b"/>
        </g>
      </svg>
    )
  }
}
